import {inject, Injectable} from '@angular/core';
import {
  ContractParametersContainerResponse,
  ContractParametersControllerService,
  UpsertContractParametersContainerRequestParams,
} from '@frontend/shared';
import {Observable} from 'rxjs';
import {ImplementationTimelineResponse} from '@frontend/shared';
import {ImplementationTimelineContainerData} from './implementation-timeline/implementation-timeline-container.types';

@Injectable({providedIn: 'root'})
export class ContractParametersService {
  private readonly api = inject(ContractParametersControllerService);

  public loadContractParametersContainer(
    projectId: number,
  ): Observable<ContractParametersContainerResponse> {
    return this.api.getContractParametersContainer({projectId: projectId});
  }

  public upsertContractParametersContainer(
    upsertRequest: UpsertContractParametersContainerRequestParams,
  ): Observable<ContractParametersContainerResponse> {
    return this.api.upsertContractParametersContainer(upsertRequest);
  }

  public mapToImplementationTimelineContainerData(current: Array<ImplementationTimelineResponse>) {
    if (!current) {
      return {} as ImplementationTimelineContainerData;
    }
    return {
      data: current.map((item: ImplementationTimelineResponse) => ({
        directusModuleFunctionId: item.directusModuleFunctionId,
        officesLookupResponse: item.officesLookupResponse,
        plannedAction: item.plannedAction,
        goLiveDate: item.goLiveDate ? new Date(item.goLiveDate) : null,
        contractExpiryDate: item.contractExpiryDate ? new Date(item.contractExpiryDate) : null,
      })),
    } as ImplementationTimelineContainerData;
  }
}
